import mapFunction from './mapResources';

export default mapFunction('room_types', {
    isFetching: false,
    items: []
});